import { render, staticRenderFns } from "./ajouterLogementForm.vue?vue&type=template&id=afcc6f0a&scoped=true"
import script from "./ajouterLogementForm.vue?vue&type=script&lang=js"
export * from "./ajouterLogementForm.vue?vue&type=script&lang=js"
import style0 from "./ajouterLogementForm.vue?vue&type=style&index=0&id=afcc6f0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afcc6f0a",
  null
  
)

export default component.exports